import React, { Component } from "react";
import {
  Tabs,
  Spin,
  Modal,
  Button,
  Tooltip,
  notification,
  Modal as modal,
  Space as space,
  Button as button,
} from "antd";
import PrimaryButton from "../CommonComponent/Buttons/PrimayButton";
import "./AuthUserList.css";
import Axios from "axios";
import Config from "../../config";
import CreateTicket from "../TicketManagement/CreateTicket/CreateTicket";
import "./Incidents.css";
import DoWnDropdown from "./DownDropdown.png";
import DropdownUp from "./DropdownUp.png";
import ICon from "./ICon.png";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

export class AuthorizationDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      TicketCreatedForProps: "",
      TicketCreatedForIDProps: "",
      TicketShow: false,
      attachmentVisible: false,
      attachmentToLoad: null,
      ExpandMore: false,
      tabName: "Summary",
      authData: [],
      authDetailsLoading: false,
      getPlanName: sessionStorage.getItem("planName"),
      RequestingProvider: [],
      ServicingProvider: [],
      AdmittingProvider: [],
      Facility: [],
      AdmissionArray: [],
      DischargeArray: [],
      AttendingProvider: [],
      notesArray: [],
      contactsArray: [],
      arrowState: "",
      summaryFilter: true,
      expandedRow: null,
      noteRowExpand: null,
      ICDCodes: [],
      CPTCodes: [],
      attachmentsArray: [],
      memberDetails: [],
      lettersData: [],
      authSummaryData: [],
      authSummaryLoading: false,
      notesLoading: false,
      contactsLoading: false,
      attachmentsLoading: false,
      lettersLoading: false,
      surgeonProvider: [],
      authStatus: "",
    };
  }
  TicketShowInfo = () => {
    this.setState((state) => ({ TicketShow: true }));
  };
  TicketHideInfo = () => {
    this.setState((state) => ({ TicketShow: false }));
  };

  handleExpand = (value) => {
    if (value == "expand") {
      this.setState({ ExpandMore: true });
    } else if (value == "collapse") {
      this.setState({ ExpandMore: false });
    }
  };

  loadAuthAttachment = (FilePath) => {
    this.setState({ attachmentVisible: true });
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        // Accept: "application/pdf",
        // "Content-Disposition": "attachment",
      },
      responseType: "arraybuffer",
    };
    Axios.post(
      `${Config.Auth}/GetAuthorizationDocument`,
      {
        DocumentKey: FilePath,
      },
      axiosConfig
    )
      .then((res) => {
        let blobTypes = {
          pdf: "application/pdf",
          png: "image/PNG",
          jpg: "image/JPG",
          jpeg: "image/JPEG",
        };
        let extension = FilePath.split(".").pop().toLowerCase();
        let blob = new Blob([res.data], { type: blobTypes[extension] });

        const fileURL = URL.createObjectURL(blob);
        this.setState({ attachmentToLoad: fileURL });
      })
      .catch((err) => {
        this.setState({ attachmentVisible: false, attachmentToLoad: null });
        notification["error"]({
          message: "Document not found",
          description:
            "Sorry, we were unable to locate the attached document. Please contact administrator.",
        });
      });
  };

  arrowDirectionUp = (value, value1) => {
    this.handleRowClick(value);
    this.setState({
      summaryFilter: value1,
      arrowState: value,
      filteStatus: false,
      //  filterIconStatus : true
    });
  };

  noteFirst = (list) => {
    let NoteArr = list.filter((item) => item.includes("- Note :"));
    let RestArr = list.filter((item) => !item.includes("- Note :"));
    return [...NoteArr, ...RestArr];
  };

  arrowDirectionDown = (value, value2) => {
    this.handleRowClick(value);
    this.setState({
      summaryFilter: value2,
      arrowState: value,
      filteStatus: false,
      // filterIconStatus : true
    });
  };

  tabChange = (evt, tabName) => {
    this.setState({
      tabName: tabName,
    });

    if (tabName === "Notes") {
      this.getNotesArray();
    } else if (tabName === "Contacts") {
      this.getContactsArray();
    } else if (tabName === "Attachments") {
      this.getAttachmentsArray();
    } else if (tabName === "Letters") {
      this.getLettersData();
    } else if (tabName === "AuthSummary") {
      this.getAuthSummaryData();
    }
  };

  getAuthorizationsList = () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };

    Axios.get(
      Config.Auth +
        "/GetSummaryData?AuthID=" +
        this.props.user.AuthID +
        "&PlanName=" +
        this.state.getPlanName,
      axiosConfig
    )
      .then((res) => {
        // Axios.get(Config.api + "/GetSummaryData?AuthID=" + this.props.user.AuthID + "&PlanName=ultimate", axiosConfig).then((res) => {

        if (
          res.data.length != 0 ||
          res.data != null ||
          res.data != undefined ||
          res.data != ""
        ) {
          this.setState({
            authStatus: res.data.AuthStatus,
            authData: res.data.AuthorizationList,
            TicketCreatedForProps: res.data.AuthorizationList.MemberName,
            TicketCreatedForIDProps: this.props.user.AuthID,
            // RequestingProvider : res.data.AuthorizationList.RequestingProvider, this.props.user.AuthID
            // ServicingProvider : res.data.AuthorizationList.ServicingProvider,
            // AdmittingProvider : res.data.AuthorizationList.AdmittingProvider,
            // Facility : res.data.AuthorizationList.Facility,
            // AdmissionArray : res.data.AuthorizationList.Admission,
            // DischargeArray : res.data.AuthorizationList.Discharge,
            // AttendingProvider : res.data.AuthorizationList.AttendingProvider,
            authListLoading: true,
          });
          if (res.data.AuthorizationList.RequestingProvider != null) {
            this.setState({
              RequestingProvider: res.data.AuthorizationList.RequestingProvider,
            });
          } else {
            this.setState({
              RequestingProvider: [],
            });
          }

          if (res.data.AuthorizationList.PCP != null) {
            this.setState({
              PCP: res.data.AuthorizationList.PCP,
            });
          } else {
            this.setState({
              PCP: [],
            });
          }

          if (res.data.AuthorizationList.ServicingProvider != null) {
            this.setState({
              ServicingProvider: res.data.AuthorizationList.ServicingProvider,
            });
          } else {
            this.setState({
              ServicingProvider: [],
            });
          }

          if (res.data.AuthorizationList.AdmittingProvider != null) {
            this.setState({
              AdmittingProvider: res.data.AuthorizationList.AdmittingProvider,
            });
          } else {
            this.setState({
              AdmittingProvider: [],
            });
          }

          if (res.data.AuthorizationList.Facility != null) {
            this.setState({
              Facility: res.data.AuthorizationList.Facility,
            });
          } else {
            this.setState({
              Facility: [],
            });
          }

          if (res.data.AuthorizationList.Admission != null) {
            this.setState({
              AdmissionArray: res.data.AuthorizationList.Admission,
            });
          } else {
            this.setState({
              AdmissionArray: [],
            });
          }

          if (res.data.AuthorizationList.Discharge != null) {
            this.setState({
              DischargeArray: res.data.AuthorizationList.Discharge,
            });
          } else {
            this.setState({
              DischargeArray: [],
            });
          }
          if (res.data.AuthorizationList.AttendingProvider != null) {
            this.setState({
              AttendingProvider: res.data.AuthorizationList.AttendingProvider,
            });
          } else {
            this.setState({
              AttendingProvider: [],
            });
          }
          if (res.data.AuthorizationList.ICDCodes != null) {
            this.setState({
              ICDCodes: res.data.AuthorizationList.ICDCodes,
            });
          } else {
            this.setState({
              ICDCodes: [],
            });
          }
          if (res.data.AuthorizationList.CPTCodes != null) {
            this.setState({
              CPTCodes: res.data.AuthorizationList.CPTCodes,
            });
          } else {
            this.setState({
              CPTCodes: [],
            });
          }
          if (res.data.AuthorizationList.SurgeonProvider != null) {
            this.setState({
              surgeonProvider: res.data.AuthorizationList.SurgeonProvider,
            });
          } else {
            this.setState({
              surgeonProvider: [],
            });
          }
        } else {
          this.setState({
            authStatus: "",
            authData: [],
            authDetailsLoading: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          authData: [],
          authDetailsLoading: true,
        });
      });
  };

  getNotesArray = () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };

    Axios.get(
      Config.Auth +
        "/GetAllAuthorizationNotesByAuthorizationID?AuthID=" +
        this.props.user.AuthID +
        "&PlanName=" +
        this.state.getPlanName,
      axiosConfig
    )
      .then((res) => {
        // Axios.get(Config.api + "/GetAllAuthorizationNotesByAuthorizationID?AuthID=" + this.props.user.AuthID + "&PlanName=ultimate", axiosConfig).then((res) => {

        this.setState({
          notesArray: res.data.AuthorizationSummary,
          notesLoading: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          notesArray: [],
          notesLoading: true,
        });
      });
  };

  getContactsArray = () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };

    Axios.get(
      Config.Auth +
        "/GetAllAuthorizationContactsByAuthorizationID?AuthID=" +
        this.props.user.AuthID +
        "&PlanName=" +
        this.state.getPlanName,
      axiosConfig
    )
      .then((res) => {
        // Axios.get(Config.api + "/GetAllAuthorizationContactsByAuthorizationID?AuthID=" + this.props.user.AuthID + "&PlanName=ultimate", axiosConfig).then((res) => {
        this.setState({
          contactsArray: res.data.AuthorizationSummary,
          contactsLoading: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          contactsArray: [],
          contactsLoading: true,
        });
      });
  };

  getAttachmentsArray = () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };

    Axios.get(
      Config.Auth +
        "/GetAllAuthorizationDocumentsByAuthorizationID?AuthID=" +
        this.props.user.AuthID +
        "&PlanName=" +
        this.state.getPlanName,
      axiosConfig
    )
      .then((res) => {
        // Axios.get(Config.api + "/GetAllAuthorizationDocumentsByAuthorizationID?AuthID=" + this.props.user.AuthID + "&PlanName=ultimate", axiosConfig).then((res) => {
        this.setState({
          attachmentsArray: res.data.AuthorizationSummary,
          attachmentsLoading: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          attachmentsLoading: [],
          attachmentsLoading: true,
        });
      });
  };

  getAuthSummaryData = () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };

    Axios.get(
      Config.Auth +
        "/GetAuthorizationSummaryData?AuthID=" +
        this.props.user.AuthID +
        "&PlanName=" +
        this.state.getPlanName,
      axiosConfig
    )
      .then((res) => {
        // Axios.get(Config.api + "/GetAuthorizationSummaryData?AuthID=" + this.props.user.AuthID + "&PlanName=ultimate", axiosConfig).then((res) => {
        this.setState({
          authSummaryData: res.data.AuthorizationSummary,
          authSummaryLoading: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          authSummaryData: [],
          authSummaryLoading: true,
        });
      });
  };
  componentDidMount() {
    this.getAuthorizationsList();
    this.getMemberDetails();
    // this.getNotesArray();
    // this.getContactsArray();
    // this.getAttachmentsArray();
  }

  addEventOpen = () => {
    this.setState({
      addEventStatus: false,
      rowStatus: true,
      editEventStatus: false,
      btnStatus: true,
      isAddProduct: true,
    });
  };

  getMemberDetails = () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };
    Axios.get(
      Config.api +
        "/GetMemberHeaderDetailsByUniqueID?PlanName=" +
        sessionStorage.getItem("planName") +
        "&subscriberid=" +
        this.props.user.SubId,
      axiosConfig
    )
      .then((res) => {
        // Axios.get(Config.api + "/GetMemberHeaderDetailsByUniqueID?PlanName=ultimate" + "&subscriberid=" + this.props.user.SubId, axiosConfig).then(res => {
        // console.log(res.data)
        this.setState({
          memberDetails: res.data.MemberHeader,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          memberDetails: [],
        });
      });
  };

  getLettersData = () => {
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/json",
        "Content-type": "application/json",
      },
    };
    Axios.get(
      Config.Auth +
        "/GetAllLettersByAuthorizationId?AuthID=" +
        this.props.user.AuthID +
        "&PlanName=" +
        sessionStorage.getItem("planName"),
      axiosConfig
    )
      .then((res) => {
        // Axios.get(Config.api + "/GetAllLettersByAuthorizationId?AuthID=" + this.props.user.AuthID + "&PlanName=ultimate", axiosConfig).then(res => {
        // console.log(res.data)
        this.setState({
          lettersData: res.data.LettersList,
          lettersLoading: true,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          lettersData: [],
          lettersLoading: true,
        });
      });
  };

  handleRowClick = (rowId) => {
    const currentExpandedRow = this.state.expandedRow;
    this.setState({ expandedRow: rowId === currentExpandedRow ? null : rowId });
  };

  renderItem = (item) => {
    const itemRows = [
      <tr
        className={
          item.NoteID === this.state.arrowState &&
          this.state.summaryFilter === true
            ? "activeTableRow"
            : ""
        }
      >
        <td>
          {this.state.months[new Date(item.Date).getMonth()]}{" "}
          {new Date(item.Date).getDate()}, {new Date(item.Date).getFullYear()}
        </td>
        <td>{item.Time === "" || item.Time === null ? "------" : item.Time}</td>
        <td>
          {item.DocumentType === "" || item.DocumentType === null
            ? "------"
            : item.DocumentType}
        </td>
        <td>
          {item.CreatedBy === "" || item.CreatedBy === null
            ? "------"
            : item.CreatedBy}
        </td>
        <td>
          {item.Subject === null || item.Subject === ""
            ? "------"
            : item.Subject}
        </td>
        {/* <td onClick={() => this.handleRowClick(item.NoteID)} style={{ cursor: "pointer" }}> */}
        <td style={{ cursor: "pointer" }}>
          {item.NoteID === this.state.arrowState &&
          this.state.summaryFilter === true ? (
            <div onClick={() => this.arrowDirectionUp(item.NoteID, false)}>
              <span>
                Close{" "}
                <img
                  src={DropdownUp}
                  alt="DropdownUp"
                  style={{ marginLeft: "2px", width: "8px", height: "6px" }}
                />
              </span>
            </div>
          ) : (
            <div onClick={() => this.arrowDirectionDown(item.NoteID, true)}>
              <span className="viewButtonDesign">More Details</span>
              <img
                src={DoWnDropdown}
                style={{ marginLeft: "2px" }}
                width="8px"
                height="6px"
                alt="dorpdown"
              />
            </div>
          )}
        </td>
      </tr>,
    ];

    if (this.state.expandedRow === item.NoteID) {
      for (var i = 0; i < this.state.notesArray.length; i++) {
        if (this.state.notesArray[i].NoteID === item.NoteID) {
          const { Date, Time, CreatedBy, Subject, DocumentType, ...noA } =
            this.state.notesArray[i];

          var newObj = noA;
          for (var x in newObj) {
            if (
              newObj[x] === null ||
              newObj[x] === undefined ||
              newObj[x].length === 0
            ) {
              delete newObj[x];
            }
          }
        }
      }

      let arr = [];

      for (let [key, val] of Object.entries(newObj)) {
        if (val) {
          if (typeof val === "string")
            arr.push(
              "- " +
                `${key}`.match(/[A-Z][a-z]+|[0-9]+/g).join(" ") +
                " : " +
                `${val}`
            );
        }
        if (typeof val === "object") {
          if (key === "ListOfMedicalService") {
            var test = val.map((a) => a.Description);
            var uniqueValues = test.filter(function (x) {
              return x !== undefined && x !== "" && x !== null;
            });

            var convertedArray = uniqueValues;

            var res = ", ";
            var array_content = "";
            for (var i = 0; i < convertedArray.length; i++)
              array_content =
                array_content + (i + 1) + ". " + convertedArray[i] + res + "\n";

            // var arrayValues = uniqueValues.toString();
            arr.push(
              " - " +
                `${key}`.match(/[A-Z][a-z]+|[0-9]+/g).join(" ") +
                " : " +
                array_content
            );
          }
        }
      }
      // console.log(arr)
      itemRows.push(
        <div className="nestedContentBgcolor">
          {this.noteFirst(arr).map((item) => {
            var new1 = item.includes("List Of Medical Service") ? item.split(":") : item.split(/:(.*)/s);
            // console.log(new1[0], new1[1])
            return (
              <div className="nestedLine">
                {new1[0].includes("List Of Medical Service") === true ? (
                  <div>
                    {" "}
                    <div className="notesFirstDiv">{new1[0]}:</div>
                    <div className="notesSecondDiv p-2">
                      {new1[1].split(",").map((item) => {
                        return (
                          <ul style={{ margin: "0px", padding: "0px" }}>
                            <ol
                              className="notesSecondDiv"
                              style={{ padding: "2px 0px 2px 2px", whiteSpace: 'pre-wrap', overflowWrap: 'break-word',lineHeight:"20px" }}
                            >
                              {item}
                            </ol>
                          </ul>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <div>
                    <span className="notesFirstDiv">{new1[0]}:</span>{" "}
                    <span className="notesSecondDiv" style={{whiteSpace: 'pre-wrap', overflowWrap: 'break-word',lineHeight:"20px"}}>{new1[1]}</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      );
    }
    return itemRows;
  };

  render() {
    const Fromwhere = "Authorization";
    const TicketHideInfo = () => {
      this.setState((state) => ({ TicketShow: false }));
    };
    const warning = () => {
      modal.confirm({
        title: "Are you sure to cancel",
        content: "cancel will discard all the added data",
        onOk() {
          TicketHideInfo();
        },
        okText: "Yes, Cancel",
        cancelText: "No",
      });
    };
    const CancelButton = () => (
      <space wrap>
        <PrimaryButton
          style={{
            display: "inline-block",
            align: "right",
            verticalAlign: "middle",
            marginTop: "-34px",
          }}
          className={"details-tab p-1 pl-2 pr-2"}
          onClick={warning}
          label={"Cancel"}
        />
      </space>
    );
    const { TabPane } = Tabs;
    var user = this.props.user;
    var {
      authData,
      RequestingProvider,
      PCP,
      ServicingProvider,
      AdmittingProvider,
      Facility,
      AdmissionArray,
      DischargeArray,
      AttendingProvider,
      CPTCodes,
      ICDCodes,
      memberDetails,
      surgeonProvider,
    } = this.state;

    let allNotesRows = [];
    this.state.notesArray.forEach((item) => {
      const perNoteRows = this.renderItem(item);
      allNotesRows = allNotesRows.concat(perNoteRows);
    });

    return (
      <div className="authPage">
        <div>
          <div className="authorizationPageHeading">Authorization Details</div>
          {/* {!this.state.TicketShow && sessionStorage.getItem("planName") !== "csh" && (
            <div className="complaint-button">
              <PrimaryButton
                style={{
                  display: "inline-block",
                  align: "right",
                  verticalAlign: "middle",
                  marginTop: "-34px",
                }}
                className={"details-tab p-1 pl-2 pr-2"}
                onClick={() => this.TicketShowInfo()}
                label={"Create a Ticket"}
              />
            </div>
          )} */}
          <div className="parentDiv ">
            <div className="firstDiv">
              <div className="displayFlex borderLeftStyle">
                <div className="memberNameDiv">
                  {/* <span className="spanMemberName"></span> */}
                  <span className="memberName">
                    {authData.MemberName}.{" "}
                    <span className="age">
                      ({memberDetails.Gender}, {memberDetails.Age}Years)
                    </span>
                  </span>
                </div>

                <div>
                  <div className="memberId">Member ID</div>
                  <div className="memberIdNumber">{authData.MemberID}</div>
                </div>
              </div>

              <div className="parentOfSummary">
                <div className="userDetails">
                  <div className="userDetailsDivWidth">
                    <div>D.O.B.:</div>
                    <div className="summaryValues1">
                      {memberDetails.DateOfBirth === null ||
                      memberDetails.length === 0 ? (
                        "-------"
                      ) : (
                        <span>
                          {
                            this.state.months[
                              new Date(memberDetails.DateOfBirth).getMonth()
                            ]
                          }{" "}
                          {new Date(memberDetails.DateOfBirth).getDate()},{" "}
                          {new Date(memberDetails.DateOfBirth).getFullYear()}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="userDetailsDivWidth">
                    <div>Contact No.:</div>
                    <div className="summaryValues1">
                      {memberDetails.PhoneNumber === null ||
                      memberDetails.length === 0
                        ? "------"
                        : memberDetails.PhoneNumber}
                    </div>
                  </div>
                  <div className="userDetailsDivWidth">
                    <div>Provider ID</div>
                    <div className="summaryValues1">
                      {!PCP ||
                      PCP.length === 0
                        ? "------"
                        : PCP.ProviderIdOrCenterId}
                    </div>
                  </div>
                  <div className="userDetailsDivWidth">
                    <div>Eligibility:</div>
                    <div className="summaryValues1">
                      {memberDetails.PlanTerminationDate === null ||
                      memberDetails.length === 0 ? (
                        "------"
                      ) : (
                        <span>
                          {
                            this.state.months[
                              new Date(
                                memberDetails.PlanTerminationDate
                              ).getMonth()
                            ]
                          }{" "}
                          {new Date(
                            memberDetails.PlanTerminationDate
                          ).getDate()}
                          ,{" "}
                          {new Date(
                            memberDetails.PlanTerminationDate
                          ).getFullYear()}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="userDetails">
                  <div className="userDetailsDivWidth">
                    <div>EFF Date:</div>
                    <div className="summaryValues1">
                      {memberDetails.PlanEffectiveDate === null ||
                      memberDetails.length === 0 ? (
                        "------"
                      ) : (
                        <span>
                          {
                            this.state.months[
                              new Date(
                                memberDetails.PlanEffectiveDate
                              ).getMonth()
                            ]
                          }{" "}
                          {new Date(memberDetails.PlanEffectiveDate).getDate()},{" "}
                          {new Date(
                            memberDetails.PlanEffectiveDate
                          ).getFullYear()}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="userDetailsDivWidth">
                    <div>Country:</div>
                    <div className="summaryValues1">
                      {memberDetails.County === null ||
                      memberDetails.length === 0
                        ? "------"
                        : memberDetails.County}
                    </div>
                  </div>
                  <div className="userDetailsDivWidth">
                    <div>Plan-Sub-Group:</div>
                    <div className="summaryValues1">
                      {" "}
                      {memberDetails.PbpCode === null ||
                      memberDetails.length === 0
                        ? "------"
                        : memberDetails.PbpCode}
                    </div>
                  </div>
                  <div className="userDetailsDivWidth">
                    <div>PCP:</div>
                    <div className="summaryValues1">
                      {memberDetails.PcpName === null ||
                      memberDetails.length === 0
                        ? "------"
                        : memberDetails.PcpName}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="secondDiv parentOfSummary">
              <div className="secondDivFlex">
                <div className="radioButton"></div>
                <div>
                  <span className="rightText">Request:</span>
                  <span
                    className={user.Req === "EX" ? "expedited" : "standard"}
                  >
                    {user.Req === "EX" ? "EXPEDITED" : "STANDARD"}
                  </span>
                </div>
              </div>
              <div className="secondDivFlex">
                <div className="radioButton"></div>
                <div>
                  <span className="rightText">Auth Type: </span>
                  <span className="summaryValues">
                    {authData.AuthorizationType === null ||
                    authData.length === 0
                      ? "------"
                      : authData.AuthorizationType}
                  </span>
                </div>
              </div>
              <div className="secondDivFlex">
                <div className="radioButton"></div>
                <div>
                  <span className="rightText">Auth Status: </span>
                  <span className="summaryValues">
                    {" "}
                    {this.state.authStatus === ""
                      ? "------"
                      : this.state.authStatus}
                  </span>
                </div>
              </div>
              <div className="secondDivFlex">
                <div className="radioButton"></div>
                <div>
                  <span className="rightText">D.O.S: </span>
                  <span className="summaryValues">
                    {" "}
                    {authData.ExpectedDOS === null || authData.length === 0 ? (
                      "------"
                    ) : (
                      <span>
                        {
                          this.state.months[
                            new Date(authData.ExpectedDOS).getMonth()
                          ]
                        }{" "}
                        {new Date(authData.ExpectedDOS).getDate()},{" "}
                        {new Date(authData.ExpectedDOS).getFullYear()}
                      </span>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.TicketShow && (
          <div>
            <div className="ticket-header">Create a Ticket</div>
          </div>
        )}

        {this.state.TicketShow && (
          <div>
            <CreateTicket TicketHideInfo={this.TicketHideInfo} Fromwhere={Fromwhere} TicketCreatedForProps={this.state.TicketCreatedForProps} TicketCreatedForIDProps={this.state.TicketCreatedForIDProps}/>
          </div>
        )}

        <div style={{ marginTop: "21px" }}>
          <ul className="authTab">
            <li
              className={
                this.state.tabName === "Summary" ? "activeTab" : "inActiveTab"
              }
              onClick={(event) => this.tabChange(event, "Summary")}
            >
              Summary
            </li>
            <li
              className={
                this.state.tabName === "AuthSummary"
                  ? "activeTab"
                  : "inActiveTab"
              }
              onClick={(event) => this.tabChange(event, "AuthSummary")}
            >
              Auth Summary
            </li>
            <li
              className={
                this.state.tabName === "Notes" ? "activeTab" : "inActiveTab"
              }
              onClick={(event) => this.tabChange(event, "Notes")}
            >
              Notes
            </li>
            <li
              className={
                this.state.tabName === "Contacts" ? "activeTab" : "inActiveTab"
              }
              onClick={(event) => this.tabChange(event, "Contacts")}
            >
              Contacts
            </li>
            <li
              className={
                this.state.tabName === "Attachments"
                  ? "activeTab"
                  : "inActiveTab"
              }
              onClick={(event) => this.tabChange(event, "Attachments")}
            >
              Attachments
            </li>
            <li
              className={
                this.state.tabName === "Letters" ? "activeTab" : "inActiveTab"
              }
              onClick={(event) => this.tabChange(event, "Letters")}
            >
              Letters
            </li>
          </ul>

          {this.state.tabName === "Summary" ? (
            <div>
              <div className="basicInfomation">
                <div className="parentOfSummary">
                  <div className="basicInfomationHeading">
                    01. Basic Information
                  </div>
                  <div>
                    <div className="userDetails">
                      <div className="columnWidth">
                        <div>P.O.S</div>
                        <div className="summaryValues">
                          {authData.PlaceOfService === null ||
                          authData.length === 0 ? (
                            "------"
                          ) : (
                            <span>
                              <span>{authData.PlaceOfService}</span>
                              <img
                                src={ICon}
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  marginLeft: "2px",
                                }}
                              />
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Authorization</div>
                        <div className="summaryValues">
                          {authData.AuthorizationType === null ||
                          authData.length === 0
                            ? "-----"
                            : authData.AuthorizationType}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Type Of Care</div>
                        <div className="summaryValues">
                          {authData.TypeOfCare === null || authData.length === 0
                            ? "------"
                            : authData.TypeOfCare}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Recieved</div>
                        <div className="summaryValues">
                          {" "}
                          {authData.ReceivedDate === null ||
                          authData.length === 0 ? (
                            "-----"
                          ) : (
                            <span>
                              {
                                this.state.months[
                                  new Date(authData.ReceivedDate).getMonth()
                                ]
                              }{" "}
                              {new Date(authData.ReceivedDate).getDate()},{" "}
                              {new Date(authData.ReceivedDate).getFullYear()}
                            </span>
                          )}{" "}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>D.O.S</div>
                        <div className="summaryValues">
                          {authData.ExpectedDOS === null ||
                          authData.length === 0 ? (
                            "------"
                          ) : (
                            <span>
                              {
                                this.state.months[
                                  new Date(authData.ExpectedDOS).getMonth()
                                ]
                              }{" "}
                              {new Date(authData.ExpectedDOS).getDate()},{" "}
                              {new Date(authData.ExpectedDOS).getFullYear()}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="userDetails">
                      <div className="columnWidth">
                        <div>PCP</div>
                        <div className="summaryValues">
                          {authData.PCPFullName === null ||
                          authData.PCPFullName === "" ||
                          authData.length === 0
                            ? "------"
                            : authData.PCPFullName}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Request</div>
                        <div className="summaryValues">
                          {authData.length === 0 ? (
                            "------"
                          ) : authData.RequestType !== "Standard" ? (
                            <span style={{ color: "#D53D5C" }}>Expedited</span>
                          ) : (
                            <span style={{ color: "#40A892" }}>Standard</span>
                          )}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>
                          {user.Req === "EX"
                            ? "Part-B Medication"
                            : "Co-Management Obtain"}
                        </div>
                        <div className="summaryValues">
                          {authData.length === 0
                            ? "------"
                            : authData.IsComanagementObtained === false
                            ? "False"
                            : "True"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="basicInfomation">
                <div className="parentOfSummary">
                  <div className="basicInfomationHeading">
                    02. Requesting Provider
                  </div>
                  <div>
                    <div className="userDetails">
                      <div className="columnWidth">
                        <div>First Name</div>
                        <div className="summaryValues">
                          {RequestingProvider.FirstName === null ||
                          RequestingProvider.length === 0
                            ? "------"
                            : RequestingProvider.FirstName}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Last Name</div>
                        <div className="summaryValues">
                          {RequestingProvider.LastName === null ||
                          RequestingProvider.length === 0
                            ? "-----"
                            : RequestingProvider.LastName}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Tax ID</div>
                        <div className="summaryValues">
                          {RequestingProvider.TaxID === null ||
                          RequestingProvider.length === 0
                            ? "------"
                            : RequestingProvider.TaxID}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>NPI</div>
                        <div className="summaryValues">
                          {RequestingProvider.NPI === null ||
                          RequestingProvider.length === 0
                            ? "------"
                            : RequestingProvider.NPI}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Provider ID</div>
                        <div className="summaryValues">
                          {RequestingProvider.ProviderIdOrCenterId === null ||
                          RequestingProvider.length === 0
                            ? "------"
                            : RequestingProvider.ProviderIdOrCenterId}
                        </div>
                      </div>
                    </div>
                    {user.Req === "EX" ? (
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Type</div>
                          <div className="summaryValues">
                            {RequestingProvider.ProviderType === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.ProviderType}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact No.</div>
                          <div className="summaryValues">
                            {RequestingProvider.PhoneNumber === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.PhoneNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Fax No.</div>
                          <div className="summaryValues">
                            {RequestingProvider.FaxNumber === null ||
                            RequestingProvider.length === 0
                              ? "-----"
                              : RequestingProvider.FaxNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Speciality</div>
                          <div className="summaryValues">
                            {RequestingProvider.Specialty === null ||
                            RequestingProvider.length === 0
                              ? "-----"
                              : RequestingProvider.Specialty}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact Name</div>
                          <div className="summaryValues">
                            {RequestingProvider.ContactName === null ||
                            RequestingProvider.length === 0
                              ? "-----"
                              : RequestingProvider.ContactName}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Contact No.</div>
                          <div className="summaryValues">
                            {RequestingProvider.PhoneNumber === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.PhoneNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Fax No.</div>
                          <div className="summaryValues">
                            {RequestingProvider.FaxNumber === null ||
                            RequestingProvider.length === 0
                              ? "-----"
                              : RequestingProvider.FaxNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Speciality</div>
                          <div className="summaryValues">
                            {RequestingProvider.Specialty === null ||
                            RequestingProvider.length === 0
                              ? "-----"
                              : RequestingProvider.Specialty}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact Name</div>
                          <div className="summaryValues">
                            {RequestingProvider.ContactName === null ||
                            RequestingProvider.length === 0
                              ? "-----"
                              : RequestingProvider.ContactName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Address 01</div>
                          <div className="summaryValues">
                            {RequestingProvider.Address1 === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.Address1}
                          </div>
                        </div>
                      </div>
                    )}
                    {user.Req === "EX" ? (
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Address 01</div>
                          <div className="summaryValues">
                            {RequestingProvider.Address1 === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.Address1}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Address 02</div>
                          <div className="summaryValues">
                            {RequestingProvider.Address2 === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.Address2}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>City</div>
                          <div className="summaryValues">
                            {RequestingProvider.City === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.City}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>State</div>
                          <div className="summaryValues">
                            {RequestingProvider.State === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.State}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Zip</div>
                          <div className="summaryValues">
                            {RequestingProvider.ZipCode === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.ZipCode}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Address 02</div>
                          <div className="summaryValues">
                            {RequestingProvider.Address2 === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.Address2}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>City</div>
                          <div className="summaryValues">
                            {RequestingProvider.City === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.City}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>State</div>
                          <div className="summaryValues">
                            {RequestingProvider.State === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.State}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Zip</div>
                          <div className="summaryValues">
                            {RequestingProvider.ZipCode === null ||
                            RequestingProvider.length === 0
                              ? "------"
                              : RequestingProvider.ZipCode}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {user.Req === "EX" ? (
                <div className="basicInfomation">
                  <div className="parentOfSummary">
                    <div className="basicInfomationHeading">
                      03. Servicing Provider
                    </div>
                    <div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>First Name</div>
                          <div className="summaryValues">
                            {ServicingProvider.FirstName === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.FirstName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Last Name</div>
                          <div className="summaryValues">
                            {ServicingProvider.LastName === null ||
                            ServicingProvider.length === 0
                              ? "-----"
                              : ServicingProvider.LastName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Tax ID</div>
                          <div className="summaryValues">
                            {ServicingProvider.TaxID === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.TaxID}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>NPI</div>
                          <div className="summaryValues">
                            {ServicingProvider.NPI === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.NPI}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Provider ID</div>
                          <div className="summaryValues">
                            {ServicingProvider.ProviderIdOrCenterId === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.ProviderIdOrCenterId}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Type</div>
                          <div className="summaryValues">
                            {ServicingProvider.ProviderType === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.ProviderType}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact No.</div>
                          <div className="summaryValues">
                            {ServicingProvider.PhoneNumber === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.PhoneNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Fax No.</div>
                          <div className="summaryValues">
                            {ServicingProvider.FaxNumber === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.FaxNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Speciality</div>
                          <div className="summaryValues">
                            {ServicingProvider.Specialty === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.Specialty}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact Name</div>
                          <div className="summaryValues">
                            {ServicingProvider.ContactName === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.ContactName}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Address 01</div>
                          <div className="summaryValues">
                            {ServicingProvider.Address1 === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.Address1}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Address 02</div>
                          <div className="summaryValues">
                            {ServicingProvider.Address2 === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.Address2}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>City</div>
                          <div className="summaryValues">
                            {ServicingProvider.City === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.City}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>State</div>
                          <div className="summaryValues">
                            {ServicingProvider.State === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.State}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Zip</div>
                          <div className="summaryValues">
                            {ServicingProvider.ZipCode === null ||
                            ServicingProvider.length === 0
                              ? "------"
                              : ServicingProvider.ZipCode}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="basicInfomation">
                  <div className="parentOfSummary">
                    <div className="basicInfomationHeading">
                      03. Attending Physician
                    </div>
                    <div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>First Name</div>
                          <div className="summaryValues">
                            {AttendingProvider.FirstName === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.FirstName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Last Name</div>
                          <div className="summaryValues">
                            {AttendingProvider.LastName === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.LastName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Tax ID</div>
                          <div className="summaryValues">
                            {AttendingProvider.TaxID === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.TaxID}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>NPI</div>
                          <div className="summaryValues">
                            {AttendingProvider.NPI === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.NPI}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Provider ID</div>
                          <div className="summaryValues">
                            {AttendingProvider.ProviderIdOrCenterId === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.ProviderIdOrCenterId}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Contact No.</div>
                          <div className="summaryValues">
                            {AttendingProvider.PhoneNumber === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.PhoneNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Fax No.</div>
                          <div className="summaryValues">
                            {AttendingProvider.FaxNumber === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.FaxNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Speciality</div>
                          <div className="summaryValues">
                            {AttendingProvider.Specialty === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.Specialty}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact Name</div>
                          <div className="summaryValues">
                            {AttendingProvider.ContactName === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.ContactName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Address 01</div>
                          <div className="summaryValues">
                            {AttendingProvider.Address1 === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.Address1}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Address 02</div>
                          <div className="summaryValues">
                            {AttendingProvider.Address2 === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.Address2}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>City</div>
                          <div className="summaryValues">
                            {AttendingProvider.City === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.City}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>State</div>
                          <div className="summaryValues">
                            {AttendingProvider.State === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.State}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Zip</div>
                          <div className="summaryValues">
                            {AttendingProvider.ZipCode === null ||
                            AttendingProvider.length === 0
                              ? "------"
                              : AttendingProvider.ZipCode}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {user.Req === "EX" ? (
                ""
              ) : (
                <div className="basicInfomation">
                  <div className="parentOfSummary">
                    <div className="basicInfomationHeading">
                      04. Admitting Physician
                    </div>
                    <div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>First Name</div>
                          <div className="summaryValues">
                            {AdmittingProvider.FirstName === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.FirstName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Last Name</div>
                          <div className="summaryValues">
                            {AdmittingProvider.LastName === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.LastName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Tax ID</div>
                          <div className="summaryValues">
                            {AdmittingProvider.TaxID === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.TaxID}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>NPI</div>
                          <div className="summaryValues">
                            {AdmittingProvider.NPI === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.NPI}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Provider ID</div>
                          <div className="summaryValues">
                            {AdmittingProvider.ProviderIdOrCenterId === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.ProviderIdOrCenterId}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Contact No.</div>
                          <div className="summaryValues">
                            {AdmittingProvider.PhoneNumber === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.PhoneNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Fax No.</div>
                          <div className="summaryValues">
                            {AdmittingProvider.FaxNumber === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.FaxNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Speciality</div>
                          <div className="summaryValues">
                            {AdmittingProvider.Specialty === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.Specialty}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact Name</div>
                          <div className="summaryValues">
                            {AdmittingProvider.ContactName === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.ContactName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Address 01</div>
                          <div className="summaryValues">
                            {AdmittingProvider.Address1 === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.Address1}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Address 02</div>
                          <div className="summaryValues">
                            {AdmittingProvider.Address2 === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.Address2}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>City</div>
                          <div className="summaryValues">
                            {AdmittingProvider.City === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.City}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>State</div>
                          <div className="summaryValues">
                            {AdmittingProvider.State === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.State}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Zip</div>
                          <div className="summaryValues">
                            {AdmittingProvider.ZipCode === null ||
                            AdmittingProvider.length === 0
                              ? "------"
                              : AdmittingProvider.ZipCode}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {user.Req === "EX" ? (
                ""
              ) : (
                <div className="basicInfomation">
                  <div className="parentOfSummary">
                    <div className="basicInfomationHeading">
                      05. Surgeon Details
                    </div>
                    <div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>First Name</div>
                          <div className="summaryValues">
                            {surgeonProvider.FirstName === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.FirstName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Last Name</div>
                          <div className="summaryValues">
                            {surgeonProvider.LastName === null ||
                            surgeonProvider.length === 0
                              ? "-----"
                              : surgeonProvider.LastName}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Tax ID</div>
                          <div className="summaryValues">
                            {surgeonProvider.TaxID === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.TaxID}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>NPI</div>
                          <div className="summaryValues">
                            {surgeonProvider.NPI === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.NPI}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Provider ID</div>
                          <div className="summaryValues">
                            {surgeonProvider.ProviderIdOrCenterId === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.ProviderIdOrCenterId}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Type</div>
                          <div className="summaryValues">
                            {surgeonProvider.ProviderType === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.ProviderType}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact No.</div>
                          <div className="summaryValues">
                            {surgeonProvider.PhoneNumber === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.PhoneNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Fax No.</div>
                          <div className="summaryValues">
                            {surgeonProvider.FaxNumber === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.FaxNumber}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Speciality</div>
                          <div className="summaryValues">
                            {surgeonProvider.Specialty === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.Specialty}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Contact Name</div>
                          <div className="summaryValues">
                            {surgeonProvider.ContactName === null ||
                            surgeonProvider.length === 0
                              ? "------"
                              : surgeonProvider.ContactName}
                          </div>
                        </div>
                      </div>
                      <div className="userDetails">
                        <div className="columnWidth">
                          <div>Address 01</div>
                          <div className="summaryValues">
                            {surgeonProvider.Address1 === null ||
                            surgeonProvider.length === 0
                              ? "-----"
                              : surgeonProvider.Address1}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Address 02</div>
                          <div className="summaryValues">
                            {surgeonProvider.Address2 === null ||
                            surgeonProvider.length === 0
                              ? "-----"
                              : surgeonProvider.Address2}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>City</div>
                          <div className="summaryValues">
                            {surgeonProvider.City === null ||
                            surgeonProvider.length === 0
                              ? "-----"
                              : surgeonProvider.City}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>State</div>
                          <div className="summaryValues">
                            {surgeonProvider.State === null ||
                            surgeonProvider.length === 0
                              ? "-----"
                              : surgeonProvider.State}
                          </div>
                        </div>
                        <div className="columnWidth">
                          <div>Zip</div>
                          <div className="summaryValues">
                            {surgeonProvider.ZipCode === null ||
                            surgeonProvider.length === 0
                              ? "-----"
                              : surgeonProvider.ZipCode}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="basicInfomation">
                <div className="parentOfSummary">
                  <div className="basicInfomationHeading">
                    {" "}
                    {user.Req === "EX" ? "04." : "06."} Facility Details
                  </div>
                  <div>
                    <div className="userDetails">
                      <div className="columnWidth">
                        <div>Facility Name</div>
                        <div className="summaryValues">
                          {Facility.FullName === null || Facility.length === 0
                            ? "------"
                            : Facility.FullName}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Contact No.</div>
                        <div className="summaryValues">
                          {Facility.PhoneNumber === null ||
                          Facility.length === 0
                            ? "------"
                            : Facility.PhoneNumber}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Fax No.</div>
                        <div className="summaryValues">
                          {Facility.FaxNumber === null || Facility.length === 0
                            ? "------"
                            : Facility.FaxNumber}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Contact Name</div>
                        <div className="summaryValues">
                          {Facility.ContactName === null ||
                          Facility.length === 0
                            ? "------"
                            : Facility.ContactName}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Tax ID</div>
                        <div className="summaryValues">
                          {Facility.TaxID === null || Facility.length === 0
                            ? "------"
                            : Facility.TaxID}
                        </div>
                      </div>
                    </div>
                    <div className="userDetails">
                      <div className="columnWidth">
                        <div>NPI</div>
                        <div className="summaryValues">
                          {Facility.FacilityNPI === null ||
                          Facility.length === 0
                            ? "------"
                            : Facility.FacilityNPI}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Provider ID</div>
                        <div className="summaryValues">
                          {Facility.ProviderID === null || Facility.length === 0
                            ? "------"
                            : Facility.ProviderID}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Type</div>
                        <div className="summaryValues">
                          {Facility.FacilityType === null ||
                          Facility.length === 0
                            ? "------"
                            : Facility.FacilityType}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Address 01</div>
                        <div className="summaryValues">
                          {Facility.Address1 === null || Facility.length === 0
                            ? "------"
                            : Facility.Address1}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Address 02</div>
                        <div className="summaryValues">
                          {Facility.Address2 === null || Facility.length === 0
                            ? "------"
                            : Facility.Address2}
                        </div>
                      </div>
                    </div>
                    <div className="userDetails">
                      <div className="columnWidth">
                        <div>City</div>
                        <div className="summaryValues">
                          {Facility.City === null || Facility.length === 0
                            ? "------"
                            : Facility.City}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>State</div>
                        <div className="summaryValues">
                          {Facility.State === null || Facility.length === 0
                            ? "------"
                            : Facility.State}
                        </div>
                      </div>
                      <div className="columnWidth">
                        <div>Zip</div>
                        <div className="summaryValues">
                          {Facility.ZipCode === null || Facility.length === 0
                            ? "------"
                            : Facility.ZipCode}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="basicInfomation">
                <div className="parentOfSummary">
                  <div className="basicInfomationHeading">
                    {user.Req === "EX" ? "05." : "07."} Other DX
                  </div>
                  {this.state.ICDCodes.length != 0 && (
                    <div className="attachmentTableDiv">
                      <table className="attachmentTable summaryTable">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>DX Code</th>
                            <th>ICD DESC</th>
                          </tr>
                        </thead>
                        <tbody className="tableBody">
                          {this.state.ICDCodes.map((item, index) => {
                            if (index <= 8) {
                              var serialNumber = "0" + (index + 1);
                            } else {
                              var serialNumber = index + 1;
                            }
                            return (
                              <tr>
                                <td>{serialNumber}</td>
                                <td>
                                  {item.DiagnosisDate === "" ||
                                  this.state.ICDCodes.length === 0 ||
                                  item.DiagnosisDate === null
                                    ? "------"
                                    : this.state.months[
                                        new Date(item.DiagnosisDate).getMonth()
                                      ]}{" "}
                                  {new Date(item.DiagnosisDate).getDate()},{" "}
                                  {new Date(item.DiagnosisDate).getFullYear()}
                                </td>
                                <td>
                                  {item.ICDCode === "" ||
                                  this.state.ICDCodes.length === 0 ||
                                  item.ICDCode === null
                                    ? "------"
                                    : item.ICDCode}
                                </td>
                                <td>
                                <EllipsisWithTooltip> {item.ICDCodeDescription === "" ||
                                  this.state.ICDCodes.length === 0 ||
                                  item.ICDCodeDescription === null
                                    ? "------"
                                    : item.ICDCodeDescription}</EllipsisWithTooltip>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {this.state.ICDCodes.length === 0 && (
                    <div className="mt-5 mb-5 h6 d-flex justify-content-center">
                      <span>No data found</span>
                    </div>
                  )}
                </div>
              </div>
              {user.Req === "EX" ? (
                ""
              ) : (
                <div className="basicInfomation">
                  <div className="parentOfSummary">
                    <div className="basicInfomationHeading">
                      08. Other Procedures
                    </div>
                    {this.state.CPTCodes.length != 0 && (
                      <div className="attachmentTableDiv">
                        <table className="attachmentTable summaryTable">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Date</th>
                              <th>PROC Code</th>
                              <th>Modifier</th>
                              <th>Description</th>
                            </tr>
                          </thead>
                          <tbody className="tableBody">
                            {this.state.CPTCodes.map((item, index) => {
                              if (index <= 8) {
                                var serialNumber = "0" + (index + 1);
                              } else {
                                var serialNumber = index + 1;
                              }
                              return (
                                <tr>
                                  <td>{serialNumber}</td>
                                  <td>
                                    {item.ProcedureDate === null ||
                                    this.state.CPTCodes.length === 0 ||
                                    item.ProcedureDate === ""
                                      ? "------"
                                      : this.state.months[
                                          new Date(
                                            item.ProcedureDate
                                          ).getMonth()
                                        ]}{" "}
                                    {new Date(item.ProcedureDate).getDate()},{" "}
                                    {new Date(item.ProcedureDate).getFullYear()}
                                  </td>
                                  <td>
                                    {item.CPTCode === "" ||
                                    item.CPTCode === null ||
                                    this.state.CPTCodes.length === 0
                                      ? "------"
                                      : item.CPTCode}
                                  </td>
                                  <td>
                                    {item.CPTDescTitleInAuthSummary === "" ||
                                    item.CPTDescTitleInAuthSummary === null ||
                                    this.state.CPTCodes.length === 0
                                      ? "------"
                                      : item.CPTDescTitleInAuthSummary}
                                  </td>
                                  <td>
                                  <EllipsisWithTooltip>{item.CPTDesc === "" ||
                                    item.CPTDesc === null ||
                                    this.state.CPTCodes.length === 0
                                      ? "------"
                                      : item.CPTDesc}</EllipsisWithTooltip>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {this.state.CPTCodes.length === 0 && (
                      <div className="mt-5 mb-5 h6 d-flex justify-content-center">
                        <span>No data found</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {user.Req === "EX" ? (
                ""
              ) : (
                <div className="stBoxParent">
                  <div className="stBox">
                    <div className="parentOfSummary">
                      <div className="stBoxHeading">09. Admission Date</div>
                      <div className="stBoxText">
                        <div className="stBoxTextSubChild">From Date:</div>
                        <div className="summaryValues">
                          {AdmissionArray.AdmissionFromDate === null ||
                          AdmissionArray.length === 0 ? (
                            "------"
                          ) : (
                            <span>
                              {
                                this.state.months[
                                  new Date(
                                    AdmissionArray.AdmissionFromDate
                                  ).getMonth()
                                ]
                              }{" "}
                              {new Date(
                                AdmissionArray.AdmissionFromDate
                              ).getDate()}
                              ,{" "}
                              {new Date(
                                AdmissionArray.AdmissionFromDate
                              ).getFullYear()}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="stBoxText">
                        <div className="stBoxTextSubChild">App Days:</div>
                        <div className="summaryValues">
                          {AdmissionArray.AdmissionApprovedDays === null ||
                          AdmissionArray.length === 0
                            ? "------"
                            : AdmissionArray.AdmissionApprovedDays}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="stBox">
                    <div className="parentOfSummary">
                      <div className="stBoxHeading">10. Discharge Date</div>
                      <div className="stBoxText">
                        <div className="stBoxTextSubChild">
                          Expected Discharge Date:
                        </div>
                        <div className="summaryValues">
                          {DischargeArray.ExpectedDischargeDate === null ||
                          DischargeArray.length === 0 ? (
                            "------"
                          ) : (
                            <span>
                              {
                                this.state.months[
                                  new Date(
                                    DischargeArray.ExpectedDischargeDate
                                  ).getMonth()
                                ]
                              }{" "}
                              {new Date(
                                DischargeArray.ExpectedDischargeDate
                              ).getDate()}
                              ,{" "}
                              {new Date(
                                DischargeArray.ExpectedDischargeDate
                              ).getFullYear()}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="stBoxText">
                        <div className="stBoxTextSubChild">To DT:</div>
                        <div className="summaryValues">
                          {DischargeArray.DischargeToDate === null ||
                          DischargeArray.length === 0
                            ? "------"
                            : DischargeArray.DischargeToDate}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="stBox">
                    <div className="parentOfSummary">
                      <div className="stBoxHeading">11. L.O.S Details</div>
                      <div className="stBoxText">
                        <div className="stBoxTextSubChild">Req L.O.S:</div>
                        <div className="summaryValues">
                          {AdmissionArray.RequestedLOS === null ||
                          AdmissionArray.length === 0
                            ? "------"
                            : AdmissionArray.RequestedLOS}
                        </div>
                      </div>
                      <div className="stBoxText">
                        <div className="stBoxTextSubChild">Actual L.O.S:</div>
                        <div className="summaryValues">
                          {AdmissionArray.LOSApprovedDays === null ||
                          AdmissionArray.length === 0
                            ? "------"
                            : AdmissionArray.LOSApprovedDays}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="stBox">
                    <div className="parentOfSummary">
                      <div className="stBoxHeading">
                        12. Interim Billing Date
                      </div>
                      <div className="stBoxText">
                        <div className="stBoxTextSubChild">
                          Interim Billing Date:
                        </div>
                        <div className="summaryValues">
                          {authData.InterimBillingDate === null ||
                          authData.length === 0
                            ? "------"
                            : authData.InterimBillingDate}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : this.state.tabName === "AuthSummary" ? (
            <div className="tabsBackground">
              {this.state.authSummaryData.length != 0 &&
                this.state.authSummaryLoading === true && (
                  <div>
                    <div className="totalAuth">
                      Total Auth:{" "}
                      {this.state.authSummaryData.length < 9
                        ? " 0" + this.state.authSummaryData.length
                        : this.state.authSummaryData.length}{" "}
                    </div>
                    <div className="attachmentTableDiv">
                      <table className="attachmentTable">
                        <thead>
                          <tr>
                            <th>DOS/DOA</th>
                            <th>Exp DC</th>
                            <th>Att. Provider</th>
                            <th>Facility</th>
                            <th>Primary DX</th>
                            <th>POS</th>
                            <th>Proc Code</th>
                            <th>Proc Desc</th>
                            <th>TOC</th>
                            <th>Auth Type</th>
                            <th>Status</th>
                            <th>DX Desc</th>
                          </tr>
                        </thead>
                        <tbody className="tableBody">
                          {this.state.authSummaryData.map((item) => {
                            console.log("item", item);
                            return (
                              <tr>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    this.state.months[
                                      new Date(item.DOS).getMonth()
                                    ]
                                  }  ${new Date(item.DOS).getDate()} ${new Date(
                                    item.DOS
                                  ).getFullYear()}`}
                                >
                                  <td>
                                    {
                                      this.state.months[
                                        new Date(item.DOS).getMonth()
                                      ]
                                    }{" "}
                                    {new Date(item.DOS).getDate()},{" "}
                                    {new Date(item.DOS).getFullYear()}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    this.state.months[
                                      new Date(item.ExpDC).getMonth()
                                    ]
                                  } ${new Date(
                                    item.ExpDC
                                  ).getDate()} ${new Date(
                                    item.ExpDC
                                  ).getFullYear()}`}
                                >
                                  <td>
                                    {
                                      this.state.months[
                                        new Date(item.ExpDC).getMonth()
                                      ]
                                    }{" "}
                                    {new Date(item.ExpDC).getDate()},{" "}
                                    {new Date(item.ExpDC).getFullYear()}
                                  </td>
                                </Tooltip>

                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.AttendingProvider === null ||
                                    item.AttendingProvider === ""
                                      ? "------"
                                      : item.AttendingProvider
                                  }`}
                                >
                                  <td>
                                    {item.AttendingProvider === null ||
                                    item.AttendingProvider === ""
                                      ? "------"
                                      : item.AttendingProvider}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Facility === null ||
                                    item.Facility === ""
                                      ? "------"
                                      : item.Facility
                                  }`}
                                >
                                  <td>
                                    {item.Facility === null ||
                                    item.Facility === ""
                                      ? "------"
                                      : item.Facility}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.PrimaryDX === null ||
                                    item.PrimaryDX === ""
                                      ? "------"
                                      : item.PrimaryDX
                                  }`}
                                >
                                  <td>
                                    {item.PrimaryDX === null ||
                                    item.PrimaryDX === ""
                                      ? "------"
                                      : item.PrimaryDX}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.POS === null || item.POS === ""
                                      ? "------"
                                      : item.POS
                                  }`}
                                >
                                  <td>
                                    {item.POS === null || item.POS === ""
                                      ? "------"
                                      : item.POS}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.ProcCode === null ||
                                    item.ProcCode === ""
                                      ? "------"
                                      : item.ProcCode
                                  }`}
                                >
                                  <td>
                                    {item.ProcCode === null ||
                                    item.ProcCode === ""
                                      ? "------"
                                      : item.ProcCode}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.ProcDesc === null ||
                                    item.ProcDesc === ""
                                      ? "------"
                                      : item.ProcDesc
                                  }`}
                                >
                                  <td>
                                    {item.ProcDesc === null ||
                                    item.ProcDesc === ""
                                      ? "------"
                                      : item.ProcDesc}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.TOC === null || item.TOC === ""
                                      ? "------"
                                      : item.TOC
                                  }`}
                                >
                                  <td>
                                    {item.TOC === null || item.TOC === ""
                                      ? "------"
                                      : item.TOC}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.AuthType === null ||
                                    item.AuthType === ""
                                      ? "-----"
                                      : item.AuthType
                                  }`}
                                >
                                  <td>
                                    {item.AuthType === null ||
                                    item.AuthType === ""
                                      ? "-----"
                                      : item.AuthType}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Status === null || item.Status === ""
                                      ? "------"
                                      : item.Status
                                  }`}
                                >
                                  <td>
                                    {item.Status === null || item.Status === ""
                                      ? "------"
                                      : item.Status}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.DXDesc === null || item.DXDesc === ""
                                      ? "------"
                                      : item.DXDesc
                                  }`}
                                >
                                  <td>
                                    {item.DXDesc === null || item.DXDesc === ""
                                      ? "------"
                                      : item.DXDesc}
                                  </td>
                                </Tooltip>

                                <td style={{ cursor: "pointer" }}>
                                  {this.state.ExpandMore ? (
                                    <div
                                      onClick={() =>
                                        this.handleExpand("collapse")
                                      }
                                      style={{
                                        color: "#4C83E1",
                                        textDecoration: "underline",
                                        textAlign: "center",
                                      }}
                                    >
                                      <span>Close</span>
                                    </div>
                                  ) : (
                                    <div
                                      onClick={() =>
                                        this.handleExpand("expand")
                                      }
                                      style={{
                                        color: "#4C83E1",
                                        textDecoration: "underline",
                                        textAlign: "center",
                                      }}
                                    >
                                      <span>View</span>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {this.state.ExpandMore && (
                        <table>
                          <div style={{ margin: "11px 0px 0px 22px" }}>
                            <span className="claimNoteDesc">DX Desc: </span>
                            {this.state.authSummaryData[
                              this.state.authSummaryData.length - 1
                            ].DXDesc === null ||
                            this.state.authSummaryData[
                              this.state.authSummaryData.length - 1
                            ].DXDesc === ""
                              ? "------"
                              : this.state.authSummaryData[
                                  this.state.authSummaryData.length - 1
                                ].DXDesc}
                          </div>
                        </table>
                      )}
                    </div>
                  </div>
                )}
              {this.state.authSummaryData.length === 0 &&
                this.state.authSummaryLoading === false && (
                  <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                    <Spin size="large" tip="Loading..." />
                  </div>
                )}
              {this.state.authSummaryData.length === 0 &&
                this.state.authSummaryLoading === true && (
                  <div className="mt-5 mb-5 h5 d-flex justify-content-center">
                    <span>No data found</span>
                  </div>
                )}
            </div>
          ) : this.state.tabName === "Notes" ? (
            <div className="tabsBackground">
              {this.state.notesArray.length != 0 &&
                this.state.notesLoading === true && (
                  <div>
                    <div className="totalAuth">
                      Total Notes:{" "}
                      {this.state.notesArray.length < 9
                        ? "0" + this.state.notesArray.length
                        : this.state.notesArray.length}
                    </div>
                    <div className="attachmentTableDiv ">
                      <table className="attachmentTable tempTable1">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Note Type</th>
                            <th>Created By</th>
                            <th>Subject</th>
                            <th>Note</th>
                          </tr>
                        </thead>
                        <tbody className="tableBody">{allNotesRows}</tbody>
                      </table>
                    </div>
                  </div>
                )}
              {this.state.notesArray.length === 0 &&
                this.state.notesLoading === false && (
                  <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                    <Spin size="large" tip="Loading..." />
                  </div>
                )}
              {this.state.notesArray.length === 0 &&
                this.state.notesLoading === true && (
                  <div className="mt-5 mb-5 h5 d-flex justify-content-center">
                    <span>No data found</span>
                  </div>
                )}
            </div>
          ) : this.state.tabName === "Contacts" ? (
            <div className="tabsBackground">
              {this.state.contactsArray.length != 0 &&
                this.state.contactsLoading === true && (
                  <div>
                    <div className="totalAuth">
                      Total Contacts:
                      {this.state.contactsArray.length < 9
                        ? "0" + this.state.contactsArray.length
                        : this.state.contactsArray.length}
                    </div>
                    <div className="attachmentTableDiv">
                      <table className="attachmentTable">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Entity</th>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Details</th>
                            <th>Direction</th>
                            <th>Outcome Type</th>
                            {/* <th>Note</th> */}
                            <th>Created By</th>
                            {/* <th></th> */}
                          </tr>
                        </thead>
                        <tbody className="tableBody">
                          {this.state.contactsArray.map((item) => {
                            return (
                              <tr>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    this.state.months[
                                      new Date(item.Date).getMonth()
                                    ]
                                  } ${new Date(item.Date).getDate()} ${new Date(
                                    item.Date
                                  ).getFullYear()}`}
                                >
                                  <td>
                                    {
                                      this.state.months[
                                        new Date(item.Date).getMonth()
                                      ]
                                    }{" "}
                                    {new Date(item.Date).getDate()},{" "}
                                    {new Date(item.Date).getFullYear()}
                                  </td>
                                </Tooltip>
                                <Tooltip placement="top" title={`${item.Time}`}>
                                  <td>{item.Time}</td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Entity === null || item.Entity === ""
                                      ? "------"
                                      : item.Entity
                                  }`}
                                >
                                  <td>
                                    {item.Entity === null || item.Entity === ""
                                      ? "------"
                                      : item.Entity}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Name === null || item.Name === ""
                                      ? "------"
                                      : item.Name
                                  }`}
                                >
                                  <td>
                                    {item.Name === null || item.Name === ""
                                      ? "------"
                                      : item.Name}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Type === null || item.Type === ""
                                      ? "------"
                                      : item.Type
                                  }`}
                                >
                                  <td>
                                    {item.Type === null || item.Type === ""
                                      ? "------"
                                      : item.Type}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`{item.Details === null || item.Details === ""
                                    ? "------"
                                    : item.Details}`}
                                >
                                  <td>
                                    {item.Details === null ||
                                    item.Details === ""
                                      ? "------"
                                      : item.Details}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Direction === null ||
                                    item.Direction === ""
                                      ? "------"
                                      : item.Direction
                                  }`}
                                >
                                  <td>
                                    {item.Direction === null ||
                                    item.Direction === ""
                                      ? "------"
                                      : item.Direction}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.OutcomeType === null ||
                                    item.OutcomeType === ""
                                      ? "------"
                                      : item.OutcomeType
                                  }`}
                                >
                                  <td>
                                    {item.OutcomeType === null ||
                                    item.OutcomeType === ""
                                      ? "------"
                                      : item.OutcomeType}
                                  </td>
                                </Tooltip>
                                {/* <td>
                                  <span className="iMark">i</span>
                                </td> */}
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.CreatedBy === null ||
                                    item.CreatedBy === ""
                                      ? "------"
                                      : item.CreatedBy
                                  }`}
                                >
                                  <td>
                                    {item.CreatedBy === null ||
                                    item.CreatedBy === ""
                                      ? "------"
                                      : item.CreatedBy}
                                  </td>
                                </Tooltip>
                                {/* <td><span className="viewButtonDesign">View</span></td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              {this.state.contactsArray.length === 0 &&
                this.state.contactsLoading === false && (
                  <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                    <Spin size="large" tip="Loading..." />
                  </div>
                )}
              {this.state.contactsArray.length === 0 &&
                this.state.contactsLoading === true && (
                  <div className="mt-5 mb-5 h5 d-flex justify-content-center">
                    <span>No data found</span>
                  </div>
                )}
            </div>
          ) : this.state.tabName === "Attachments" ? (
            <div className="tabsBackground">
              {this.state.attachmentsArray.length != 0 &&
                this.state.attachmentsLoading === true && (
                  <div>
                    <div className="totalAuth">
                      Total Attachments:{" "}
                      {this.state.attachmentsArray.length < 9
                        ? "0" + this.state.attachmentsArray.length
                        : this.state.attachmentsArray.length}
                    </div>
                    <div className="attachmentTableDiv">
                      <Modal
                        title="View Document"
                        visible={this.state.attachmentVisible}
                        onOk={() =>
                          this.setState({
                            attachmentVisible: false,
                            attachmentToLoad: null,
                          })
                        }
                        onCancel={() =>
                          this.setState({
                            attachmentVisible: false,
                            attachmentToLoad: null,
                          })
                        }
                        cancelButtonProps={{ style: { display: "none" } }}
                        width={840}
                      >
                        {this.state.attachmentToLoad ? (
                          <iframe
                            src={this.state.attachmentToLoad}
                            height="720px"
                            width="100%"
                            style={{ border: "0" }}
                          />
                        ) : (
                          <div
                            style={{ textAlign: "center", padding: "3rem 0" }}
                          >
                            <Spin />
                          </div>
                        )}
                      </Modal>
                      <table className="attachmentTable">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Document Name</th>
                            <th>Document Type</th>
                            <th>Created By</th>
                            <th>Document Name</th>
                            {/* <th>File</th> */}
                          </tr>
                        </thead>
                        <tbody className="tableBody">
                          {this.state.attachmentsArray.map((item) => {
                            console.log(item);
                            return (
                              <tr>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    this.state.months[
                                      new Date(item.Date).getMonth()
                                    ]
                                  } ${new Date(item.Date).getDate()} ${new Date(
                                    item.Date
                                  ).getFullYear()}`}
                                >
                                  <td>
                                    {
                                      this.state.months[
                                        new Date(item.Date).getMonth()
                                      ]
                                    }{" "}
                                    {new Date(item.Date).getDate()},{" "}
                                    {new Date(item.Date).getFullYear()}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Time === null || item.Time === ""
                                      ? "------"
                                      : item.Time
                                  }`}
                                >
                                  <td>
                                    {item.Time === null || item.Time === ""
                                      ? "------"
                                      : item.Time}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.DocumentName === null ||
                                    item.DocumentName === ""
                                      ? "------"
                                      : item.DocumentName
                                  }`}
                                >
                                  <td>
                                    {item.DocumentName === null ||
                                    item.DocumentName === ""
                                      ? "------"
                                      : item.DocumentName}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.DocumentType === null ||
                                    item.DocumentType === ""
                                      ? "------"
                                      : item.DocumentType
                                  }`}
                                >
                                  <td>
                                    {item.DocumentType === null ||
                                    item.DocumentType === ""
                                      ? "------"
                                      : item.DocumentType}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.CreatedBy === null ||
                                    item.CreatedBy === ""
                                      ? "------"
                                      : item.CreatedBy
                                  }`}
                                >
                                  <td>
                                    {item.CreatedBy === null ||
                                    item.CreatedBy === ""
                                      ? "------"
                                      : item.CreatedBy}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.DocumentName === null ||
                                    item.DocumentName === ""
                                      ? "------"
                                      : item.DocumentName
                                  }`}
                                >
                                  <td>
                                    {/* <a className='anchor_theme' href={item.FilePath} target='_blank'>
                                      {item.DocumentName === null || item.DocumentName === "" ? "------" : item.DocumentName}
                                      </a> */}
                                    <PrimaryButton
                                      type="link"
                                      onClick={() =>
                                        this.loadAuthAttachment(item.FilePath)
                                      }
                                      label={item.DocumentName === null ||
                                        item.DocumentName === ""
                                          ? "------"
                                          : item.DocumentName}
                                    />
                                  </td>
                                </Tooltip>
                                {/* <td><span className="viewButtonDesign">View</span></td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              {this.state.attachmentsArray.length === 0 &&
                this.state.attachmentsLoading === false && (
                  <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                    <Spin size="large" tip="Loading..." />
                  </div>
                )}
              {this.state.attachmentsArray.length === 0 &&
                this.state.attachmentsLoading === true && (
                  <div className="mt-5 mb-5 h5 d-flex justify-content-center">
                    <span>No data found</span>
                  </div>
                )}
            </div>
          ) : (
            <div className="tabsBackground">
              {this.state.lettersData.length != 0 &&
                this.state.lettersLoading === true && (
                  <div>
                    <div className="totalAuth">
                      Total Attachments:{" "}
                      {this.state.lettersData.length < 9
                        ? "0" + this.state.lettersData.length
                        : this.state.lettersData.length}
                    </div>
                    <div className="attachmentTableDiv">
                      <table className="attachmentTable">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Letter Reason</th>
                            <th>Status</th>
                            <th>User Name</th>
                            {/* <th>File</th> */}
                          </tr>
                        </thead>
                        <tbody className="tableBody">
                          {this.state.lettersData.map((item) => {
                            return (
                              <tr>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    this.state.months[
                                      new Date(item.Date).getMonth()
                                    ]
                                  } ${new Date(item.Date).getDate()} ${new Date(
                                    item.Date
                                  ).getFullYear()}`}
                                >
                                  <td>
                                    {
                                      this.state.months[
                                        new Date(item.Date).getMonth()
                                      ]
                                    }{" "}
                                    {new Date(item.Date).getDate()},{" "}
                                    {new Date(item.Date).getFullYear()}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Time === null || item.Time === ""
                                      ? "------"
                                      : item.Time
                                  }`}
                                >
                                  <td>
                                    {item.Time === null || item.Time === ""
                                      ? "------"
                                      : item.Time}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Reason === "" || item.Reason === null
                                      ? "------"
                                      : item.Reason
                                  }`}
                                >
                                  <td>
                                    {item.Reason === "" || item.Reason === null
                                      ? "------"
                                      : item.Reason}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.Status === "" || item.Status === null
                                      ? "------"
                                      : item.Status
                                  }`}
                                >
                                  <td>
                                    {item.Status === "" || item.Status === null
                                      ? "------"
                                      : item.Status}
                                  </td>
                                </Tooltip>
                                <Tooltip
                                  placement="top"
                                  title={`${
                                    item.CreatedBy === "" ||
                                    item.CreatedBy === null
                                      ? "------"
                                      : item.CreatedBy
                                  }`}
                                >
                                  <td>
                                    {item.CreatedBy === "" ||
                                    item.CreatedBy === null
                                      ? "------"
                                      : item.CreatedBy}
                                  </td>
                                </Tooltip>
                                {/* <td><span className="viewButtonDesign">View</span></td> */}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              {this.state.lettersData.length === 0 &&
                this.state.lettersLoading === false && (
                  <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                    <Spin size="large" tip="Loading..." />
                  </div>
                )}
              {this.state.lettersData.length === 0 &&
                this.state.lettersLoading === true && (
                  <div className="mt-5 mb-5 h5 d-flex justify-content-center">
                    <span>No data found</span>
                  </div>
                )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AuthorizationDetails;
